import { getCLOnCallOverlapMessage, getCLShiftCondition } from './utils';

type CLReservationConditionProps = {
  csActiveReservationCase?: {
    caseId: string | null;
    caseName: string | null;
  };
  overlapOnCallShiftStart?: string | null;
  overlapOnCallShiftEnd?: string | null;
  phoneSupportStart?: string | null;
  phoneSupportEnd?: string | null;
};

export const CLReservationCondition = ({
  csActiveReservationCase,
  overlapOnCallShiftStart,
  overlapOnCallShiftEnd,
  phoneSupportStart,
  phoneSupportEnd,
}: CLReservationConditionProps) => {
  const shiftCondition =
    phoneSupportStart && phoneSupportEnd ? getCLShiftCondition(phoneSupportStart, phoneSupportEnd) : null;

  const onCallOverlapMessage = getCLOnCallOverlapMessage(
    phoneSupportStart,
    phoneSupportEnd,
    overlapOnCallShiftStart,
    overlapOnCallShiftEnd,
  );

  return (
    <div className="flex flex-col gap-1">
      {shiftCondition && <div className="text-m-r">{shiftCondition}</div>}
      {onCallOverlapMessage && <div className="text-s-r text-base-20">{onCallOverlapMessage}</div>}
      {csActiveReservationCase && (
        <div className="text-s-r text-base-20">
          On Case as CS <span className="text-danger-20">{csActiveReservationCase?.caseName}</span>
        </div>
      )}
    </div>
  );
};
